var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item "},[_c('router-link',{attrs:{"to":_vm.UrlLink}},[_c('a',[_vm._v(_vm._s(_vm.RipeavMore))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }